// extracted by mini-css-extract-plugin
export default {"contactContainer":"contact_contactContainer__Lefo-"};